
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Loader extends Vue {
  @Prop({ default: 'black' }) color!: string;
  @Prop({ default: 50 }) size!: number;
  @Prop({ default: '0.1' }) opacity!: number | string;
}
